import axios from 'axios';

export function getProductAttributes(product, region, margin, name) {
  return axios
    .get(process.env.REACT_APP_HOST + 'getProductAttributes', {
      params: {
        product: product,
        region: region,
        margin: margin,
        name: name
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}
